// src/hooks/pricingUnits/useForceDeleteAllPricingUnits.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllPricingUnits } from "../../api/apiPricingUnits";
import parseError from "../../utils/parseError";

const useForceDeleteAllPricingUnits = () => {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllPricingUnitsMutation,
        isPending,
        isLoading,
    } = useMutation({
        mutationFn: forceDeleteAllPricingUnits,
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["pricingUnits"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to permanently delete pricing units");
        },
    });

    return {
        forceDeleteAllPricingUnits: forceDeleteAllPricingUnitsMutation,
        isPending: isPending || isLoading,
    };
};

export default useForceDeleteAllPricingUnits;
